import {Button, DialogActions, DialogContent, DialogTitle, TextField, Alert, useMediaQuery, useTheme} from "@mui/material";
import {IntegrationDialog as Dialog, IntegrationProviderGrid} from "../IntegrationDesign";
import {SettingsDialogDescription} from "../../SettingsDialog";
import React, {useEffect, useState, useCallback} from "react";
import Spinner from "../../../spinner/Spinner";
import {sharedAffiliateNetworkService} from "../../../../service/sharedAffiliateNetworkService";

function ChooseAffiliateNetworkIntegration(props) {

    const theme = useTheme();
    const [loading, setLoading] = useState(true);
    const [requestError, setRequestError] = useState("");
    const [templates, setTemplates] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const integrations = ["Sedo", "System1", "Tonic", "Ads.com", "Shopify"];

    const [open, setOpen] = useState(true);

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleChange = event => {
        setSearchQuery(event.target.value);
    };

    const selectIntegration = (item) => {
        if (item?.name === "Sedo") {
            props.history.push({pathname: "/settings/integrations/sedo", state: {from: props.location}});
        }
        if (item?.name === "System1") {
            props.history.push({pathname: "/settings/integrations/system1", state: {from: props.location}});
        }
        if (item?.name === "Bodis") {
            props.history.push({pathname: "/settings/integrations/bodis", state: {from: props.location}});
        }
        if (item?.name === "Tonic") {
            props.history.push({pathname: "/settings/integrations/tonic", state: {from: props.location}});
        }
        if (item?.name === "Ads.com") {
            props.history.push({pathname: "/settings/integrations/ads-com", state: {from: props.location}});
        }
        if (item?.name === "Shopify") {
            props.history.push({pathname: "/settings/integrations/shopify", state: {from: props.location}});
        }
    };

    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        setOpen(false);
        props.history.push({pathname: "/settings/integrations", state: {from: props.location}});
    }, [props]);

    const filteredTemps = !searchQuery
        ? templates
        : templates?.filter(item =>
            item?.name?.toLowerCase().includes(searchQuery.toLocaleLowerCase())
        );

    useEffect(() => {
        async function fetchData() {
            setRequestError("");
            setLoading(true);
            await sharedAffiliateNetworkService.read().then((response) => {
                if (response !== null && response !== undefined) {
                    setTemplates(response?.sharedAffiliateNetworks);
                }
            }).catch((error) => {
                if (error?.response?.data?.error) {
                    setRequestError(error.response.data.error);
                }
            }).finally(() => {
                setLoading(false);
            });
        }

        if (templates === null) {
            fetchData();
        }
    }, [templates]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth fullScreen={fullScreen} maxWidth="sm" aria-labelledby="choose-affiliate-network-integration">
            <DialogTitle id="choose-affiliate-network-integration">Choose affiliate network
                <SettingsDialogDescription>Connect a network to sync campaign revenue and conversions.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent sx={{minHeight: 280, position: 'relative'}}>
                {loading && <Spinner overComponentBox noBackShadow/>}
                {requestError && <Alert severity="error" variant="filled" sx={{mb: 2}}>{requestError}</Alert>}
                <TextField variant="outlined" size="small" margin="dense" label="Search providers" name="affiliate-network"
                    placeholder="Search by provider name" fullWidth slotProps={{inputLabel: {shrink: true}}}
                    value={searchQuery} onChange={handleChange}/>
                {!loading && !requestError && <IntegrationProviderGrid templates={filteredTemps?.filter(item => integrations.includes(item?.name))} onSelect={selectIntegration}/>}
            </DialogContent>
            <DialogActions><Button onClick={handleClose} color="inherit">Cancel</Button></DialogActions>
        </Dialog>
    );
}

export default ChooseAffiliateNetworkIntegration;
